import React, { useState, useEffect } from 'react';
import { BoxWithMargin } from 'components-core';
import { observer } from 'mobx-react';
import AccountServices from '@ncl/modules/account/services/AccountServices';
import { useStore } from '@store';

import {
  Wrapper,
  UserDisplay,
  Character,
  Divider,
  Actions,
  ActionList,
  LayersIcon,
  UserIcon,
  LogoutIcon,
  CloseButton,
} from './AccountActionsStyles';
import AccountStore from '../../../../../modules/account/store/AccountStore';
import { truncateString, displayErrorAlert } from '../../../../../utils';
import CreditsBalance from '../CreditsBalance';

const AccountActions = () => {
  const [boxOpen, setBoxOpen] = useState(false);
  const sharedStore = useStore('sharedStore');

  const { creditsBalance } = sharedStore;
  const { currentUser } = AccountStore;
  const { email, displayName } = currentUser;

  useEffect(() => {
    async function fetchCreditsBalance() {
      await AccountServices.updateBalance();
    }

    fetchCreditsBalance();
  }, []);

  useEffect(() => {
    window.addEventListener('click', handleClickOutsideActions);

    return () => {
      window.removeEventListener('click', handleClickOutsideActions);
    };
  }, []);

  function handleClickOutsideActions(e) {
    if (
      !document.getElementById('user-actions')?.contains(e.target) &&
      !document.getElementById('user-display')?.contains(e.target)
    ) {
      setBoxOpen(false);
    }
  }

  async function logoutUserAndRedirect(e) {
    e.preventDefault();

    try {
      await AccountServices.logoutKeycloak();
    } catch (error) {
      displayErrorAlert(error.message);
    }

    AccountServices.removeAccessTokenCookie();

    if (process.env.REACT_APP_FEATURE_KEYCLOAK_AUTH === 'true') {
      AccountServices.removeRefreshTokenCookie();
    }

    window.location.assign(`${process.env.REACT_APP_SITE_URL}`);
    return true;
  }

  function renderBalance() {
    if (!creditsBalance || !creditsBalance.displayBalance) {
      return <Divider />;
    }

    return (
      <BoxWithMargin
        responsiveWidth="calc(100% + 48px)"
        desktopWidth="calc(100% + 48px)"
        responsive={{ bottom: '6px', top: '20px' }}
        desktop={{ bottom: '6px', top: '20px' }}
      >
        <CreditsBalance balance={creditsBalance.balance} />
      </BoxWithMargin>
    );
  }

  return (
    <Wrapper>
      {displayName && (
        <UserDisplay
          onClick={() => setBoxOpen(!boxOpen)}
          id="user-display"
          data-testid="user-display-btn"
        >
          <Character character={displayName[0]} />
          <p>{truncateString(displayName, 23)}</p>
          <span />
        </UserDisplay>
      )}
      {boxOpen ? (
        <Actions id="user-actions" data-actions="true">
          <CloseButton onClick={() => setBoxOpen(false)} />
          <Character character={displayName[0]} size="56px" fontSize="20px" />
          <h6 data-cy="nomeTomadorLogado">{displayName}</h6>
          <p data-cy="emailTomadorlogado">{email}</p>

          {renderBalance()}

          <ActionList>
            <a href="/painel" data-cy="AcessarMeuPainel">
              <LayersIcon />
              Meu Painel
            </a>
            <a href="/conta/meus-dados" data-testid="AccessarMeusDados">
              <UserIcon />
              Meus dados
            </a>
            <a href="/logout" onClick={logoutUserAndRedirect} data-cy="RealizarLogoutUsuario">
              <LogoutIcon />
              Sair
            </a>
          </ActionList>
        </Actions>
      ) : null}
    </Wrapper>
  );
};

export default observer(AccountActions);
